import React, { useState, useEffect, useCallback } from "react";
import testimonials from "../data/testimonials";
import Deco from "./Deco";

const TestimonialSlide = ({ item }) => (
  <div className="testimonial-card__slide">
    <blockquote className="testimonial-card__text">{item.quote}</blockquote>
    <div className="testimonial-card__author">
      {item.image ? (
        <img
          className="testimonial-card__avatar"
          src={item.image}
          alt={item.name}
        />
      ) : (
        <div className="testimonial-card__avatar testimonial-card__avatar--placeholder">
          {item.name.charAt(0)}
        </div>
      )}
      <div className="testimonial-card__author-info">
        <strong className="testimonial-card__name">{item.name}</strong>
        <span className="testimonial-card__company">{item.company}</span>
      </div>
    </div>
  </div>
);

const Testimonial = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const total = testimonials.length;

  const goTo = useCallback(
    (index) => {
      if (isAnimating || index === activeIndex) return;
      setIsAnimating(true);
      setTimeout(() => {
        setActiveIndex(index);
        setIsAnimating(false);
      }, 300);
    },
    [activeIndex, isAnimating]
  );

  const goNext = useCallback(() => {
    setIsAnimating(true);
    setTimeout(() => {
      setActiveIndex((prev) => (prev + 1) % total);
      setIsAnimating(false);
    }, 300);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(goNext, 6000);
    return () => clearInterval(timer);
  }, [goNext]);

  return (
    <div className="container-full" style={{ position: "relative", overflow: "hidden" }}>
      <Deco name="three" className="deco-test deco-test--left" />
      <div className="testimonial-wrap">
        <div className="container">
          <div className="testimonial-card">
            <span className="testimonial-card__quote-mark">&ldquo;</span>

            {/* All slides stacked — tallest sets the height */}
            <div className="testimonial-card__stage">
              {testimonials.map((item, i) => (
                <div
                  key={item.id}
                  className={`testimonial-card__content ${
                    i === activeIndex
                      ? isAnimating
                        ? "testimonial-card__content--exiting"
                        : "testimonial-card__content--active"
                      : "testimonial-card__content--hidden"
                  }`}
                  aria-hidden={i !== activeIndex}
                >
                  <TestimonialSlide item={item} />
                </div>
              ))}
            </div>

            {total > 1 && (
              <div className="testimonial-card__dots">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    className={`testimonial-card__dot ${
                      i === activeIndex ? "testimonial-card__dot--active" : ""
                    }`}
                    onClick={() => goTo(i)}
                    aria-label={`Go to testimonial ${i + 1}`}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
